var exports = {
  "Nr": "x234b8571--d489c0--card",
  "e0": "x234b8571--d489c0--top-content",
  "WD": "x234b8571--d489c0--labels",
  "Mn": "x234b8571--d489c0--provider",
  "wm": "x234b8571--d489c0--logo",
  "eB": "x234b8571--d489c0--bottom-content",
  "Fm": "x234b8571--d489c0--factoid",
};

module.exports = exports;
